import React, { Component } from "react";
import { connect } from "react-redux";
import "@ant-design/compatible/assets/index.css";
import { MinusCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import {
  Button,
  Select,
  Table,
  Form,
  message,
  Input,
  InputNumber,
  DatePicker,
  Switch,
} from "antd";
import moment from "moment";
import { hotelBulkUpload, hotelGet } from "../../../store/actions/index";
import { mypPMSlist } from "../../../utils/mappingData";

const { Option } = Select;
const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
const statArray = [
  "Report Set-Up Pending",
  "Report Set-Up",
  "WIP Report Set-Up",
  "Client Success",
  "Technical",
  "UAT",
  "Audit I",
  "Audit II",
  "Go Live Pending",
  "Live",
  "Delayed",
  "Pending Business",
  "Future Business",
  "Lost",
  "Sold",
  "Soft Live",
];
const hotellocations = ["IS", "S3"];
const timezones = [
  "AKST",
  "PST",
  "CST",
  "EST",
  "MT",
  "MDT",
  "AST",
  "HST",
  "NST",
];

class BulkHotelCreationTable extends Component {
  state = {
    tableOneData: [],
    start: false,
    btnDisable: false,
  };

  tableOneFormRef = React.createRef();

  componentDidMount() {
    this.setState({
      tableOneData: this.props.excelData,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.excelData !== this.props.excelData) {
      this.setState({
        tableOneData: this.props.excelData,
      });
      this.tableOneFormRef.current.resetFields();
    }
  }

  addRow = () => {
    const tableOneData = [...this.state.tableOneData];
    const newObj = {
      Hotel_Name: "",
      Hotel_Code: "",
      Rooms: 0,
      Sign_Type: "2",
      Hotel_Email_Address: "",
      HotelLocation: "S3",
      QC_App_Copy_From_Hotel_Code: "",
      PMS: [],
      Status: "Live",
      Hotel_Go_Live: undefined,
      QC_Enabled: false,
      Timezone: undefined,
      QC_DailyTime: undefined,
      QC_WeeklyDay: undefined,
      QC_MonthlyDate: undefined,
      QC_DaysToQueryData: undefined,
      QC_BackdateCheckDaily: undefined,
      QC_BackdateCheckWeekly: undefined,
      QC_BackdateCheckMonthly: undefined,
      QC_Email_DailyQCRpt_CC: "",
      QC_Email_MissingRpt_CC: "",
      QC_SendMissingRptEmail: false,
      QC_SendEscalationRptEmail: false,
      QC_EscalationIgnoreLevelEmail: false,
      IS_SignatureIndex: "",
      QC_SignatureSource: "",
      QC_EnablePeriodicUpdate: false,
      AI_Enabled: false,
      MYP_Create_Or_Update: false,
      split_by_sub_header : "2",
      IntelliSight_Plus: false,
      Serverless_Migration: false,
    };
    let tableVals = { ...this.tableOneFormRef.current.getFieldsValue() };
    tableVals[Object.keys(tableVals).length + 1] = newObj;

    // console.log(tableVals,tableOneData,(tableOneData.length+1).toString());
    this.setState(
      {
        tableOneData: [
          ...tableOneData,
          {
            ...newObj,
            _id: (tableOneData.length + 1).toString(),
          },
        ],
      },
      () => {
        this.tableOneFormRef.current.setFieldsValue(tableVals);
        // console.log(this.tableOneFormRef.current,'form reference')
      }
    );
  };

  handleDelete = (key) => {
    const tableOneData = [...this.state.tableOneData];
    this.setState({
      tableOneData: tableOneData.filter((item) => item._id !== key),
    });
  };

  onFinish = async (values) => {
    let tableOneData = [...this.state.tableOneData];
    if (values) {
      this.setState({ start: true, btnDisable: true });
      for (const [k, a] of Object.entries(tableOneData)) {
        tableOneData[k]={...tableOneData[k], status: <LoadingOutlined />}
      }
      this.setState({
        tableOneData: tableOneData,
      });

      for (const [k, a] of Object.entries(values)) {
        const bulkUserCreationResutl = await this.props.hotelBulkUpload({
          ...a,
          Hotel_Go_Live: moment.isMoment(a.Hotel_Go_Live)
            ? moment.utc(
                a.Hotel_Go_Live.format("YYYY-MM-DD HH:mm:ss"),
                "YYYY-MM-DD HH:mm:ss"
              )
            : a.Hotel_Go_Live,
          QC_DailyTime: moment.isMoment(a.QC_DailyTime)
            ? moment.utc(
                a.QC_DailyTime.format("YYYY-MM-DD HH:mm:ss"),
                "YYYY-MM-DD HH:mm:ss"
              )
            : a.QC_DailyTime,
          primary_hmg_id: this.props.hmgSelect,
        });
        const objIndex = tableOneData.findIndex((obj) => obj._id == k);
        tableOneData = [...tableOneData]
        tableOneData[objIndex]={... tableOneData[objIndex], status: bulkUserCreationResutl.message}
        
        this.setState({
          tableOneData: tableOneData,
        });
      }
      // await this.props.hotelGet();
      this.setState({ btnDisable: false });
    }
  };

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  render = () => {
    const { excelData } = this.props;
    const tableOneInitialValues = {};

    if (excelData) {
      // console.log(excelData,'excelData');
      excelData.forEach((a) => {
        tableOneInitialValues[a._id] = {};
        tableOneInitialValues[a._id] = { ...a };
      });
    }

    let columns = [
      {
        title: "Hotel Code",
        dataIndex: "Hotel_Code",
        render: (_, record) => (
          <Form.Item
            name={[record._id, "Hotel_Code"]}
            rules={[{ required: true, message: "adfdf" }]}
          >
            <Input placeholder="Please Select Hotel Code" />
          </Form.Item>
        ),
        width: "200px",
      },
      {
        title: "Hotel Name",
        dataIndex: "Hotel_Name",
        render: (val, record) => (
          <Form.Item
            name={[record._id, "Hotel_Name"]}
            rules={[{ required: true, message: "adfdf" }]}
          >
            <Input placeholder="Please Select Hotel Name" />
          </Form.Item>
        ),
        width: "200px",
      },
      {
        title: "IS Hotel Name",
        dataIndex: "IS_HotelName",
        render: (val, record) => (
          <Form.Item
            name={[record._id, "IS_HotelName"]}
            rules={[{ required: true, message: "adfdf" }]}
          >
            <Input placeholder="Please Select IS Hotel Name" />
          </Form.Item>
        ),
        width: "200px",
      },
      {
        title: "MYP Create Or Update",
        dataIndex: "MYP_Create_Or_Update",
        render: (idx, record) => (
          <Form.Item
            name={[record._id, "MYP_Create_Or_Update"]}
            // rules={[]}
            valuePropName="checked"
          >
            <Switch
              disabled={
                process.env.REACT_APP_PLATFORM_TYPE &&
                process.env.REACT_APP_PLATFORM_TYPE === "MARRIOTT"
              }
            />
          </Form.Item>
        ),
        width: "200px",
      },
      {
        title: "MYP Hotel Name",
        dataIndex: "MYP_Hotel_Name",
        render: (val, record, key) => (
          <Form.Item
            name={[record._id, "MYP_Hotel_Name"]}
            // rules={[{
            //   validator: async (rule, value) => {
            //     const formData = this.tableOneFormRef.current.getFieldsValue();
            //     const currentVal = formData[key+1];
            //     if(currentVal===undefined){
            //       return Promise.reject('Unable to validate MYP_Hotel_Name')
            //     }
            //     if(currentVal.MYP_Create_Or_Update && currentVal.MYP_Hotel_Name==null){
            //       return Promise.reject('MYP_Hotel_Name required')
            //     }
            //     return Promise.resolve();
            //   }
            // }]}
          >
            <Input placeholder="Please Select MYP Hotel Name" />
          </Form.Item>
        ),
        width: "200px",
      },
      {
        title: "MYP PMS",
        dataIndex: "MYP_PMS",
        render: (val, record, key) => (
          <Form.Item
            name={[record._id, "MYP_PMS"]}
            rules={[
              {
                validator: async (rule, value) => {
                  const formData =
                    this.tableOneFormRef.current.getFieldsValue();
                  const currentVal = formData[key + 1];
                  if (currentVal === undefined) {
                    return Promise.reject("Unable to validate MYP_PMS");
                  }
                  if (
                    currentVal.MYP_Create_Or_Update &&
                    (typeof currentVal.MYP_PMS !== "string" ||
                      currentVal.MYP_PMS.length === 0)
                  ) {
                    return Promise.reject("MYP_PMS required");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            {/* <Input placeholder="Please Select MYP PMS" /> */}
            <Select
              showSearch
              optionFilterProp="children"
              placeholder="Please Select MYP PMS"
            >
              {mypPMSlist.map((el) => (
                <Option key={el.name} value={el.name}>
                  {el.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        ),
        width: "200px",
      },
      {
        title: "MYP Hotel Id",
        dataIndex: "MYP_Hotel_Id",
        render: (idx, record) => (
          <Form.Item
            name={[record._id, "MYP_Hotel_Id"]}
            rules={[
              { type: "number", message: "myp hotel id need to a number" },
            ]}
          >
            <InputNumber step={1} min={1} placeholder="MYP Hotel Id" />
          </Form.Item>
        ),
        width: "200px",
      },
      {
        title: "Rooms",
        dataIndex: "Rooms",
        render: (val, record) => (
          <Form.Item
            name={[record._id, "Rooms"]}
            rules={[{ type: "number", message: "Rooms need to be a number" }]}
          >
            <InputNumber />
          </Form.Item>
        ),
        width: "200px",
      },
      {
        title: "Sign Type",
        dataIndex: "Sign_Type",
        render: (val, record) => (
          <Form.Item
            name={[record._id, "Sign_Type"]}
            rules={[{ required: true, message: "adfdf" }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              placeholder="Please enter Sign Type!"
            >
              <Option value="3">PandaDoc</Option>
              <Option value="2">Docusign</Option>
              <Option value="1">None</Option>
            </Select>
          </Form.Item>
        ),
        width: "200px",
      },
      {
        title: "Hotel Email Address",
        dataIndex: "Hotel_Email_Address",
        render: (val, record) => (
          <Form.Item
            name={[record._id, "Hotel_Email_Address"]}
            rules={[
              { required: true, message: "adfdf" },
              {
                type: "email",
                message: "hotel email need to be a valid email",
              },
            ]}
          >
            <Input placeholder="Please Select Hotel Email Address" />
          </Form.Item>
        ),
        width: "200px",
      },
      {
        title: "GM Email",
        dataIndex: "GM_Email_Address",
        render: (val, record) => (
          <Form.Item
            name={[record._id, "GM_Email_Address"]}
            rules={[
              { required: true, message: "adfdf" },
              {
                type: "email",
                message: "GM email need to be a valid email",
              },
            ]}
          >
            <Input placeholder="Please Select GM Email Address" />
          </Form.Item>
        ),
        width: "200px",
      },

      // {
      //     title: "QC Cutoff Time",
      //     dataIndex: 'QC_Cutoff_Time',
      //     render:(val,record)=>(<Form.Item
      //         name={[record._id, 'QC_Cutoff_Time']}
      //         rules={[{ required: true, message: 'adfdf' }]}
      //       >
      //         {/* <Input /> */}
      //         <DatePicker format={'YYYY-MM-DD HH:mm:ss'} showTime={true} />
      //       </Form.Item>),
      //     required: true,
      // },
      {
        title: "Hotel Location",
        dataIndex: "HotelLocation",
        render: (val, record) => (
          <Form.Item
            name={[record._id, "HotelLocation"]}
            rules={[{ required: true, message: "adfdf" }]}
          >
            <Select
              disabled
              defaultValue="S3"
              showSearch
              optionFilterProp="children"
              placeholder="Please enter file location!"
            >
              {hotellocations.map((el, index) => (
                <Option key={index} value={el}>
                  {el}
                </Option>
              ))}
            </Select>
          </Form.Item>
        ),
        required: true,
        width: "200px",
      },
      {
        title: "QC App Copy From Hotel Code",
        dataIndex: "QC_App_Copy_From_Hotel_Code",
        render: (val, record) => (
          <Form.Item
            name={[record._id, "QC_App_Copy_From_Hotel_Code"]}
            // rules={[{ required: true, message: 'adfdf' }]}
          >
            <Input placeholder="Please Select Hotel Email Address" />
          </Form.Item>
        ),
        required: true,
        width: "200px",
      },
      {
        title: "PMS",
        dataIndex: "PMS",
        render: (val, record, key) => (
          <Form.Item
            name={[record._id, "PMS"]}
            rules={[
              { required: true, message: "PMS required" },
              //   {
              //   validator: async (rule, value) => {
              //     const formData = this.tableOneFormRef.current.getFieldsValue();
              //     const currentVal = formData[key+1];
              //     if(currentVal===undefined){
              //       return Promise.reject('Unable to validate PMS')
              //     }
              //     if([undefined,null,''].includes(currentVal.QC_App_Copy_From_Hotel_Code) && [undefined,null,''].includes(currentVal.PMS)){
              //       return Promise.reject('PMS required')
              //     }
              //     return Promise.resolve();
              //   }
              // }
            ]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              placeholder="Please Select PMS"
              mode="multiple"
            >
              {this.props.pms.map((el, index) => (
                <Option key={index} value={el._id}>
                  {el.pms_name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        ),
        required: true,
        width: "200px",
      },
      {
        title: "Status",
        dataIndex: "Status",
        render: (val, record) => (
          <Form.Item
            name={[record._id, "Status"]}
            rules={[
              {
                required: true,
                message: "Please select your hotel status!",
              },
            ]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              placeholder="Please enter hotel status!"
            >
              {statArray.map((el) => (
                <Option key={el} value={el}>
                  {el}
                </Option>
              ))}
            </Select>
          </Form.Item>
        ),
        required: true,
        width: "200px",
      },
      {
        title: "Hotel Go Live",
        dataIndex: "Hotel_Go_Live",
        render: (val, record, key) => (
          <Form.Item
            name={[record._id, "Hotel_Go_Live"]}
            rules={[
              {
                validator: async (rule, value) => {
                  const formData =
                    this.tableOneFormRef.current.getFieldsValue();
                  const currentVal = formData[key + 1];
                  if (currentVal === undefined) {
                    return Promise.reject("Unable to validate Hotel_Go_Live");
                  }
                  if (
                    ["Live", "Soft Live", "UAT"].includes(currentVal.Status) &&
                    currentVal.Hotel_Go_Live == null
                  ) {
                    return Promise.reject("Hotel_Go_Live required");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <DatePicker
              format={"YYYY-MM-DD"}
              // showTime={true}
            />
          </Form.Item>
        ),
        required: true,
        width: "200px",
      },
      {
        title: "QC Enabled",
        dataIndex: "QC_Enabled",
        render: (val, record) => {
          // console.log(record,'record')
          return (
            <Form.Item
              name={[record._id, "QC_Enabled"]}
              rules={[{ required: true, message: "adfdf" }]}
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          );
        },
        required: true,
        width: "200px",
      },
      {
        title: "Timezone",
        dataIndex: "Timezone",
        render: (val, record, key) => (
          <Form.Item
            name={[record._id, "Timezone"]}
            rules={[
              { required: true, message: "Timezone required" },
              //   {
              //   validator: async (rule, value) => {
              //     const formData = this.tableOneFormRef.current.getFieldsValue();
              //     const currentVal = formData[key+1];
              //     if(currentVal===undefined){
              //       return Promise.reject('Unable to validate Timezone')
              //     }
              //     if([undefined,null,''].includes(currentVal.QC_App_Copy_From_Hotel_Code) && [undefined,null,''].includes(currentVal.Timezone)){
              //       return Promise.reject('Timezone required')
              //     }
              //     return Promise.resolve();
              //   }
              // }
            ]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              placeholder="Please select your time zone!"
            >
              {timezones.map((el) => (
                <Option key={el} value={el}>
                  {el}
                </Option>
              ))}
            </Select>
          </Form.Item>
        ),
        required: true,
        width: "200px",
      },
      {
        title: "SS3U Hotel Mapping Name",
        dataIndex: "SS3U_Hotel_Mapping_Name",
        render: (val, record) => (
          <Form.Item
            name={[record._id, "SS3U_Hotel_Mapping_Name"]}
            // rules={[{ required: true, message: 'adfdf' }]}
          >
            <Input placeholder="SS3U Hotel Mapping Name" />
          </Form.Item>
        ),
        required: true,
        width: "200px",
      },
      {
        title: "QC Daily Time",
        dataIndex: "QC_DailyTime",
        render: (val, record, key) => (
          <Form.Item
            name={[record._id, "QC_DailyTime"]}
            rules={[
              {
                validator: async (rule, value) => {
                  const formData =
                    this.tableOneFormRef.current.getFieldsValue();
                  const currentVal = formData[key + 1];
                  if (currentVal === undefined) {
                    return Promise.reject("Unable to validate QC_DailyTime");
                  }
                  if (
                    [undefined, null, ""].includes(
                      currentVal.QC_App_Copy_From_Hotel_Code
                    ) &&
                    [undefined, null, ""].includes(currentVal.QC_DailyTime)
                  ) {
                    return Promise.reject("QC_DailyTime required");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <DatePicker format={"YYYY-MM-DD HH:mm:ss"} showTime={true} />
          </Form.Item>
        ),
        required: true,
        width: "200px",
      },
      {
        title: "QC Weekly Day",
        dataIndex: "QC_WeeklyDay",
        render: (val, record, key) => (
          <Form.Item
            name={[record._id, "QC_WeeklyDay"]}
            rules={[
              {
                validator: async (rule, value) => {
                  const formData =
                    this.tableOneFormRef.current.getFieldsValue();
                  const currentVal = formData[key + 1];
                  if (currentVal === undefined) {
                    return Promise.reject("Unable to validate QC_WeeklyDay");
                  }
                  if (
                    [undefined, null, ""].includes(
                      currentVal.QC_App_Copy_From_Hotel_Code
                    ) &&
                    [undefined, null, ""].includes(currentVal.QC_WeeklyDay)
                  ) {
                    return Promise.reject("QC_WeeklyDay required");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Select placeholder="Please Select QC Weeklyday">
              {days.map((el) => (
                <Option key={el} value={el}>
                  {el}
                </Option>
              ))}
            </Select>
          </Form.Item>
        ),
        required: true,
        width: "200px",
      },

      {
        title: "QC Monthly Date",
        dataIndex: "QC_MonthlyDate",
        render: (val, record, key) => (
          <Form.Item
            name={[record._id, "QC_MonthlyDate"]}
            rules={[
              {
                validator: async (rule, value) => {
                  const formData =
                    this.tableOneFormRef.current.getFieldsValue();
                  const currentVal = formData[key + 1];
                  if (currentVal === undefined) {
                    return Promise.reject("Unable to validate QC_MonthlyDate");
                  }
                  if (
                    [undefined, null, ""].includes(
                      currentVal.QC_App_Copy_From_Hotel_Code
                    ) &&
                    [undefined, null, ""].includes(currentVal.QC_MonthlyDate)
                  ) {
                    return Promise.reject("QC_MonthlyDate required");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <InputNumber min={1} step={1} />
          </Form.Item>
        ),
        width: "200px",
      },
      {
        title: "QC Days To Query Data",
        dataIndex: "QC_DaysToQueryData",
        render: (val, record, key) => {
          return (
            <Form.Item
              name={[record._id, "QC_DaysToQueryData"]}
              rules={[
                {
                  validator: async (rule, value) => {
                    const formData =
                      this.tableOneFormRef.current.getFieldsValue();
                    const currentVal = formData[key + 1];
                    if (currentVal === undefined) {
                      return Promise.reject(
                        "Unable to validate QC_DaysToQueryData"
                      );
                    }
                    if (
                      [undefined, null, ""].includes(
                        currentVal.QC_App_Copy_From_Hotel_Code
                      ) &&
                      [undefined, null, ""].includes(
                        currentVal.QC_DaysToQueryData
                      )
                    ) {
                      return Promise.reject("QC_DaysToQueryData required");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber min={0} step={1} />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "QC Backdate Check Daily",
        dataIndex: "QC_BackdateCheckDaily",
        render: (val, record, key) => {
          return (
            <Form.Item
              name={[record._id, "QC_BackdateCheckDaily"]}
              rules={[
                {
                  validator: async (rule, value) => {
                    const formData =
                      this.tableOneFormRef.current.getFieldsValue();
                    const currentVal = formData[key + 1];
                    if (currentVal === undefined) {
                      return Promise.reject(
                        "Unable to validate QC_BackdateCheckDaily"
                      );
                    }
                    if (
                      [undefined, null, ""].includes(
                        currentVal.QC_App_Copy_From_Hotel_Code
                      ) &&
                      [undefined, null, ""].includes(
                        currentVal.QC_BackdateCheckDaily
                      )
                    ) {
                      return Promise.reject("QC_BackdateCheckDaily required");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber min={0} step={1} />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "QC Backdate Check Weekly",
        dataIndex: "QC_BackdateCheckWeekly",
        render: (val, record, key) => {
          return (
            <Form.Item
              name={[record._id, "QC_BackdateCheckWeekly"]}
              rules={[
                {
                  validator: async (rule, value) => {
                    const formData =
                      this.tableOneFormRef.current.getFieldsValue();
                    const currentVal = formData[key + 1];
                    if (currentVal === undefined) {
                      return Promise.reject(
                        "Unable to validate QC_BackdateCheckWeekly"
                      );
                    }
                    if (
                      [undefined, null, ""].includes(
                        currentVal.QC_App_Copy_From_Hotel_Code
                      ) &&
                      [undefined, null, ""].includes(
                        currentVal.QC_BackdateCheckWeekly
                      )
                    ) {
                      return Promise.reject("QC_BackdateCheckWeekly required");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber min={0} step={1} />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "QC Backdate Check Monthly",
        dataIndex: "QC_BackdateCheckMonthly",
        render: (val, record, key) => {
          return (
            <Form.Item
              name={[record._id, "QC_BackdateCheckMonthly"]}
              rules={[
                {
                  validator: async (rule, value) => {
                    const formData =
                      this.tableOneFormRef.current.getFieldsValue();
                    const currentVal = formData[key + 1];
                    if (currentVal === undefined) {
                      return Promise.reject(
                        "Unable to validate QC_BackdateCheckMonthly"
                      );
                    }
                    if (
                      [undefined, null, ""].includes(
                        currentVal.QC_App_Copy_From_Hotel_Code
                      ) &&
                      [undefined, null, ""].includes(
                        currentVal.QC_BackdateCheckMonthly
                      )
                    ) {
                      return Promise.reject("QC_BackdateCheckMonthly required");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber min={0} step={1} />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "QC Email Daily QC Rpt CC",
        dataIndex: "QC_Email_DailyQCRpt_CC",
        render: (val, record, key) => {
          return (
            <Form.Item
              name={[record._id, "QC_Email_DailyQCRpt_CC"]}
              // rules={[{
              //   validator: async (rule, value) => {
              //     const formData = this.tableOneFormRef.current.getFieldsValue();
              //     const currentVal = formData[key+1];
              //     if(currentVal===undefined){
              //       return Promise.reject('Unable to validate QC_Email_DailyQCRpt_CC')
              //     }
              //     if([undefined,null,''].includes(currentVal.QC_App_Copy_From_Hotel_Code) && [undefined,null,''].includes(currentVal.QC_Email_DailyQCRpt_CC)){
              //       return Promise.reject('QC_Email_DailyQCRpt_CC required')
              //     }
              //     return Promise.resolve();
              //   }
              // }]}
            >
              <Input placeholder="Please Select QC Email Daily QC Rpt CC" />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "QC Email Missing Rpt CC",
        dataIndex: "QC_Email_MissingRpt_CC",
        render: (val, record, key) => {
          return (
            <Form.Item
              name={[record._id, "QC_Email_MissingRpt_CC"]}
              // rules={[{
              //   validator: async (rule, value) => {
              //     const formData = this.tableOneFormRef.current.getFieldsValue();
              //     const currentVal = formData[key+1];
              //     if(currentVal===undefined){
              //       return Promise.reject('Unable to validate QC_Email_MissingRpt_CC')
              //     }
              //     if([undefined,null,''].includes(currentVal.QC_App_Copy_From_Hotel_Code) && [undefined,null,''].includes(currentVal.QC_Email_MissingRpt_CC)){
              //       return Promise.reject('QC_Email_MissingRpt_CC required')
              //     }
              //     return Promise.resolve();
              //   }
              // }]}
            >
              <Input placeholder="Please Select QC Email Missing Rpt CC" />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "QC Send Missing Rpt Email",
        dataIndex: "QC_SendMissingRptEmail",
        render: (val, record) => {
          return (
            <Form.Item
              name={[record._id, "QC_SendMissingRptEmail"]}
              rules={[{ required: true, message: "asdasd" }]}
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "QC Send Escalation Rpt Email",
        dataIndex: "QC_SendEscalationRptEmail",
        render: (val, record) => {
          return (
            <Form.Item
              name={[record._id, "QC_SendEscalationRptEmail"]}
              rules={[{ required: false, message: "asdasd" }]}
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "QC Escalation Ignore Level Email",
        dataIndex: "QC_EscalationIgnoreLevelEmail",
        render: (val, record) => {
          return (
            <Form.Item
              name={[record._id, "QC_EscalationIgnoreLevelEmail"]}
              rules={[{ required: true, message: "asdasd" }]}
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "IS Signature Index",
        dataIndex: "IS_SignatureIndex",
        render: (val, record, key) => {
          return (
            <Form.Item
              name={[record._id, "IS_SignatureIndex"]}
              rules={[
                {
                  validator: async (rule, value) => {
                    const formData =
                      this.tableOneFormRef.current.getFieldsValue();
                    const currentVal = formData[key + 1];
                    if (currentVal === undefined) {
                      return Promise.reject(
                        "Unable to validate IS_SignatureIndex"
                      );
                    }
                    if (
                      [undefined, null, ""].includes(
                        currentVal.QC_App_Copy_From_Hotel_Code
                      ) &&
                      [undefined, null, ""].includes(
                        currentVal.IS_SignatureIndex
                      )
                    ) {
                      return Promise.reject("IS_SignatureIndex required");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input placeholder="Please Select IS Signature Index" />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "QC Signature Source",
        dataIndex: "QC_SignatureSource",
        render: (val, record, key) => {
          return (
            <Form.Item
              name={[record._id, "QC_SignatureSource"]}
              rules={[
                {
                  validator: async (rule, value) => {
                    const formData =
                      this.tableOneFormRef.current.getFieldsValue();
                    const currentVal = formData[key + 1];
                    if (currentVal === undefined) {
                      return Promise.reject(
                        "Unable to validate QC_SignatureSource"
                      );
                    }
                    if (
                      [undefined, null, ""].includes(
                        currentVal.QC_App_Copy_From_Hotel_Code
                      ) &&
                      [undefined, null, ""].includes(
                        currentVal.QC_SignatureSource
                      )
                    ) {
                      return Promise.reject("QC_SignatureSource required");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input placeholder="Please Select QC Signature Source" />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "QC Enable Periodic Update",
        dataIndex: "QC_EnablePeriodicUpdate",
        render: (val, record) => {
          return (
            <Form.Item
              name={[record._id, "QC_EnablePeriodicUpdate"]}
              rules={[{ required: true, message: "asdasd" }]}
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "AI Enabled",
        dataIndex: "AI_Enabled",
        render: (val, record) => {
          return (
            <Form.Item
              name={[record._id, "AI_Enabled"]}
              rules={[{ required: true, message: "asdasd" }]}
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "IntelliSight Plus",
        dataIndex: "IntelliSight_Plus",
        render: (val, record) => {
          console.log(record, "record");
          return (
            <Form.Item
              name={[record._id, "IntelliSight_Plus"]}
              rules={[{ required: true, message: "asdasd" }]}
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "Serverless Migration",
        dataIndex: "Serverless_Migration",
        render: (val, record) => {
          return (
            <Form.Item
              name={[record._id, "Serverless_Migration"]}
              rules={[{ required: true, message: "asdasd" }]}
              valuePropName="checked"
            >
              <Switch
                disabled={
                  process.env.REACT_APP_PLATFORM_TYPE &&
                  process.env.REACT_APP_PLATFORM_TYPE === "GENERIC"
                }
              />
            </Form.Item>
          );
        },
        width: "200px",
      },
      {
        title: "Split Reports By Sub Header",
        dataIndex: "split_by_sub_header",
        render: (val, record, key) => (
          <Form.Item
            name={[record._id, "split_by_sub_header"]}
            rules={[{ required: true, message: "adfdf" }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              placeholder="Please Select Split Reports By Sub Header">
              <Option value="2">Parent</Option>
              <Option value="1">Yes</Option>
              <Option value="0">No</Option>
            </Select>
          </Form.Item>
        ),
        required: true,
        width: "200px",
      },
      // {
      //     title: "QC App Mgt Group",
      //     dataIndex: 'QC_App_Mgt_Group',
      //     render:(val,record)=>(<Form.Item
      //         name={[record._id, 'QC_App_Mgt_Group']}
      //         rules={[{ required: true, message: 'adfdf' }]}
      //       >
      //         <Input />
      //       </Form.Item>),
      //     required: true,
      // },
      // {
      //     title: "QC App TimeZone",
      //     dataIndex: 'QC_App_TimeZone',
      //     render:(val,record)=>(<Form.Item
      //         name={[record._id, 'QC_App_TimeZone']}
      //         rules={[{ required: true, message: 'adfdf' }]}
      //       >
      //         <Input />
      //       </Form.Item>),
      //     required: true,
      // },
      {
        title: "Remove",
        dataIndex: "operation",
        width: "80px",
        fixed: "right",
        align: "center",
        render: (text, record) => (
          <Button
            size="small"
            type="link"
            shape="circle"
            disabled={this.state.btnDisable}
            icon={<MinusCircleOutlined className="dynamic-delete-button" />}
            onClick={() => this.handleDelete(record._id)}
          ></Button>
        ),
      },
    ];

    if (this.state.start) {
      columns.push({
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: "150px",
        fixed: "right",
        align: "center",
      });
    }

    return (
      <Form
        ref={this.tableOneFormRef}
        onFinish={this.onFinish}
        onFinishFailed={this.onFinishFailed}
        initialValues={tableOneInitialValues}
        scrollToFirstError={true}
        className="is_form_3"
      >
        <Table
          dataSource={this.state.tableOneData}
          columns={columns}
          size="small"
          rowKey="_id"
          pagination={false}
          scroll={{ x: 2150 }}
        />
        {this.props.hmgSelect !== undefined ? (
          <div style={{ textAlign: "center", paddingTop: "20px" }}>
            <Button
              type="primary"
              disabled={this.state.btnDisable}
              style={{ marginRight: "20px" }}
              onClick={this.addRow}
            >
              Add Row
            </Button>
            <Button
              type="primary"
              disabled={this.state.btnDisable}
              htmlType="submit"
            >
              Process
            </Button>
          </div>
        ) : null}
      </Form>
    );
  };
}

// const mapStateToProps = state => {
//   return {
//     pmsGetData: state.api.pmsGetData
//   };
// };

const mapStateToDispatch = (dispatch) => ({
  hotelGet: () => dispatch(hotelGet()),
  hotelBulkUpload: (data) => dispatch(hotelBulkUpload(data)),
});
export default connect(null, mapStateToDispatch)(BulkHotelCreationTable);
